import { HitModel } from '../../models/hit.model';
import { ViewTreeNode } from '../../models/view.tree-node';

export class EngineNodesStateModel {
    hit: HitModel;
    selectedNode: ViewTreeNode;
    hoveredNode: ViewTreeNode;
    checkedNodes: ViewTreeNode[];

    querying: boolean;
}
